<template>
  <div>
    <a ref="link" :href="url" target="_blank" />
  </div>
</template>
<script type="es6">
export default {
  data () {
    return {
      url: ''
    };
  },
  components: {},
  computed: {},
  methods: {
    openWindow (url, other) {
      this.url = url;
      this.$nextTick(() => {
        this.$refs.link.click();
        this.$confirm('正在签章，请完成签章操作后点击 “完成签章” 或者直接选择 “退出签章”。', '提示', {
          confirmButtonText: '完成签章',
          cancelButtonText: '退出签章',
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(() => {
          this.$emit('CompleteEsign', { isComplete: true, other });
        }).catch(() => {
          this.$emit('CompleteEsign', { isComplete: false, other });
        });
      });
    }
  },
  mounted () {

  }
};
</script>
<style lang="sass"></style>
